<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="acad_1">
      <div class="text-box">
        <div>พันธมิตรสินเชื่อออนไลน์ที่เชื่อถือได้</div>
        <p>แฟลชเงินยินดีที่จะเป็นพันธมิตรการให้กู้ยืมออนไลน์ที่น่าเชื่อถือของคุณ ช่วยให้ผู้ใช้แก้ปัญหาความต้องการทางการเงินของพวกเขาได้อย่างง่ายดายและปลอดภัย</p>
      </div>
    </div>
    <div class="acad-2">
      <div class="text-box">
        <div class="text-1">ข้อดีของแฟลชเงิน</div>
        <div class="text-2">เป้าหมายการดำเนินงานของแฟลชเงินคือการสร้างแพลตฟอร์มบริการทางการเงินออนไลน์ที่เชื่อถือได้และมีประสิทธิภาพ</div>
      </div>
      <div class="list-box">
        <div class="item item_1">
          <img src="../assets/acad_1.png" alt="">
          <div>การปฏิบัติตามกฎระเบียบ</div>
          <p>แฟลชเงินได้รับการควบคุมโดยสถาบันการเงินไทยเพื่อให้แน่ใจว่าบริการสินเชื่อทั้งหมดเป็นไปตามกฎระเบียบทางการเงินของไทย และจัดหาผลิตภัณฑ์ทางการเงินที่ถูกกฎหมายและเป็นไปตามข้อกำหนด</p>
        </div>
        <div class="item item_2">
          <img src="../assets/acad_2.png" alt="">
          <div>อัตราดอกเบี้ยที่โปร่งใส</div>
          <p>อัตราดอกเบี้ยและค่าธรรมเนียมทั้งหมดบนแพลตฟอร์มนั้นเปิดกว้างและโปร่งใส ช่วยให้ผู้ใช้สามารถเข้าใจต้นทุนสินเชื่อได้อย่างชัดเจนและหลีกเลี่ยงค่าธรรมเนียมที่ซ่อนอยู่</p>
        </div>
        <div class="item item_3">
          <img src="../assets/acad_3.png" alt="">
          <div>ทางเลือกที่ยืดหยุ่น</div>
          <p>ผู้ใช้สามารถเลือกสินเชื่อระยะยาวหรือผ่อนชำระได้ตามความต้องการและเพลิดเพลินกับตัวเลือกสินเชื่อที่ยืดหยุ่น</p>
        </div>
      </div>
      <div class="mate-box">
        <div class="item item_4">
          <img src="../assets/acad_4.png" alt="">
          <div>สนับสนุนลูกค้า</div>
          <p>แฟลชเงินให้บริการลูกค้าออนไลน์แบบเรียลไทม์เพื่อตอบคำถามของผู้ใช้ได้ตลอดเวลาและรับประกันว่าผู้ใช้จะได้รับความช่วยเหลืออย่างทันท่วงทีระหว่างการใช้งาน</p>
        </div>
        <div class="item item_5">
          <img src="../assets/acad_5.png" alt="">
          <div>ความปลอดภัยของข้อมูล</div>
          <p>แพลตฟอร์มนี้ใช้เทคโนโลยีการเข้ารหัสข้อมูลขั้นสูงเพื่อปกป้องความเป็นส่วนตัวและข้อมูลส่วนบุคคลของผู้ใช้อย่างเคร่งครัด และรับประกันความปลอดภัยของข้อมูล</p>
        </div>
      </div>
    </div>

    <div class="acad-3">
      <div class="img-box">
        <!-- <div class="img-text-box">
          <img src="../assets/acad_7.png" alt="">
          <div class="text-box">
            <div>1132123</div>
            <p>31156156156</p>
          </div>
        </div> -->
      </div>
      <div class="text-box">
        <div class="title">ความตั้งใจเดิมของแฟลชเงิน</div>
        <div class="erse-box">
          <div>เข้าถึงบริการทางการเงินได้สะดวก</div>
          <p>การลดความซับซ้อนของขั้นตอนการสมัครทำให้ผู้ใช้สามารถสมัครขอสินเชื่อผ่านโทรศัพท์มือถือได้ทุกที่ทุกเวลา หลีกเลี่ยงขั้นตอนที่ยุ่งยากของสถาบันการเงินแบบเดิมๆ</p>
        </div>
        <div class="erse-box">
          <div>ความโปร่งใสและเป็นธรรม</div>
          <p>ให้ข้อมูลดอกเบี้ยและค่าธรรมเนียมที่ชัดเจน ช่วยให้ผู้ใช้เข้าใจแหล่งที่มาและวิธีการคำนวณค่าธรรมเนียมแต่ละรายการ ทำให้มั่นใจได้ว่ากระบวนการกู้ยืมมีความโปร่งใสและยุติธรรม</p>
        </div>
        <div class="erse-box">
          <div>ความปลอดภัยของข้อมูลและการปกป้องความเป็นส่วนตัว</div>
          <p>เทคโนโลยีการเข้ารหัสขั้นสูงและมาตรการรักษาความปลอดภัยถูกนำมาใช้เพื่อปกป้องข้อมูลส่วนบุคคลและความเป็นส่วนตัวของผู้ใช้ และให้แน่ใจว่าข้อมูลของผู้ใช้ปลอดภัย</p>
        </div>
      </div>
    </div>

    <div class="acad-4">
      <div class="title">ข้อดีของการเงินออนไลน์</div>
      <div class="sbtitle">การเงินออนไลน์ช่วยให้ผู้ใช้แก้ปัญหาทางการเงินได้อย่างรวดเร็ว ผู้ใช้สามารถสมัครออนไลน์แบบไร้กระดาษซึ่งมีความยืดหยุ่นและสะดวกสบาย</div>
      <div class="list-box">
        <div class="item-box">
          <img src="../assets/acad_8.png" alt="">
          <div>ความสะดวก</div>
          <ul>
            <li>สมัครสินเชื่อได้ทุกที่ทุกเวลาด้วยมือถือเพียงเครื่องเดียว หมดขั้นตอนยุ่งยากของสถาบันการเงินแบบเดิมๆ</li>
          </ul>
        </div>
        <div class="item-box">
          <img src="../assets/acad_9.png" alt="">
          <div>ความปลอดภัย</div>
          <ul>
            <li>เทคโนโลยีการเข้ารหัสขั้นสูงถูกนำมาใช้เพื่อให้แน่ใจว่าข้อมูลผู้ใช้และความเป็นส่วนตัวได้รับการปกป้องอย่างเต็มที่</li>
          </ul>
        </div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    toSub() {
      alert("ส่งเรียบร้อยแล้ว");
    },
  },
};
</script>

<style lang="less" scoped>
.acad_1 {
  background: url(../assets/header.png);
  background-size: 100% 100%;
  height: 850px;
  position: relative;

  .text-box {
    width: 650px;
    position: absolute;
    top: 270px;
    left: 938px;

    div {
      font-weight: 900;
      font-size: 100px;
      color: #0E0729;
    }

    p {
      font-weight: 400;
      font-size: 20px;
      color: #0E0729;
      margin-top: 16px;
    }
  }
}

.acad-2 {
  padding: 150px 360px;

  .text-box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .text-1 {
      font-weight: bold;
      font-size: 52px;
      color: #333333;
    }

    .text-2 {
      font-weight: 400;
      font-size: 20px;
      color: #888888;
      width: 600px;
    }
  }

  .list-box {
    display: flex;
    align-items: self-start;
    justify-content: space-between;
    margin-top: 80px;

    .item {
      padding: 60px 36px;


      img {
        width: 160px;
      }

      div {
        font-weight: bold;
        font-size: 20px;
        color: #101566;
        margin-top: 32px;
      }

      p {
        font-weight: 500;
        font-size: 14px;
        color: #627A95;
        margin-top: 8px;
      }
    }

    .item_1 {
      width: 230px;
      height: 330px;
      background: #EDF1FF;
      border-radius: 20px 20px 20px 20px;
    }

    .item_2 {
      width: 420px;
      height: 330px;
      background: #FFFFFF;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #D4DBE3;
    }

    .item_3 {
      width: 230px;
      height: 330px;
      background: #FFFFFF;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #D4DBE3;
    }
  }

  .mate-box {
    display: flex;
    align-items: self-start;
    justify-content: space-between;
    margin-top: 40px;

    .item {
      padding: 60px 36px;
      width: 500px;
      height: 280px;

      img {
        width: 160px;
      }

      div {
        font-weight: bold;
        font-size: 20px;
        color: #101566;
        margin-top: 32px;
      }

      p {
        font-weight: 500;
        font-size: 14px;
        color: #627A95;
        margin-top: 8px;
      }
    }

    .item_4 {
      background: #fff;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #D4DBE3;
    }

    .item_5 {
      background: #EDF1FF;
      border-radius: 20px 20px 20px 20px;

    }
  }
}

.acad-3 {
  padding: 0px 360px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .img-box {
    width: 426px;
    height: 470px;
    background: url(../assets/acad_6.png);
    background-size: 100% 100%;
    position: relative;

    .img-text-box {
      position: absolute;
      width: 275px;
      height: 86px;
      background: #FFFFFF;
      box-shadow: 5px 12px 30px 0px rgba(14, 7, 41, 0.1);
      border-radius: 26px 26px 26px 26px;
      bottom: 40px;
      left: 145px;
      padding: 20px;
      display: flex;
      align-items: flex-start;
      justify-content: center;

      img {
        width: 49px;
      }

      .text-box {
        margin-left: 20px;

        div {
          font-weight: bold;
          font-size: 20px;
          color: #0E0729;
        }

        p {
          font-weight: 400;
          font-size: 16px;
          color: #827F8D;
        }
      }
    }
  }

  .text-box {
    width: 500px;
    ;

    .title {
      font-weight: bold;
      font-size: 52px;
      color: #333333;
    }

    .erse-box {
      margin-top: 50px;

      div {
        font-weight: bold;
        font-size: 18px;
        color: #0E0729;
      }

      p {
        font-weight: 400;
        font-size: 20px;
        color: #827F8D;
      }
    }
  }
}

.acad-4 {
  padding: 150px 360px;

  .title {
    font-weight: bold;
    font-size: 52px;
    color: #333333;
    text-align: center;
  }

  .sbtitle {
    font-weight: 400;
    font-size: 20px;
    color: #888888;
    margin-top: 25px;
    text-align: center;
  }

  .list-box {
    margin-top: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item-box {
      padding: 36px;
      width: 500px;
      min-height: 407px;
      background: #FFFFFF;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #D4DBE3;

      img {
        width: 400px;
      }

      div {
        font-weight: 600;
        font-size: 24px;
        color: #223053;
        margin-top: 18px;
      }

      ul {
        margin-top: 12px;
      }

      li {
        font-weight: 500;
        font-size: 18px;
        color: #223053;
      }
    }
  }
}
</style>
